import script from "./autoLoginEdgp.vue?vue&type=script&setup=true&lang=ts"
export * from "./autoLoginEdgp.vue?vue&type=script&setup=true&lang=ts"

import "./autoLoginEdgp.vue?vue&type=style&index=0&id=b5b5567a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5b5567a"]])

export default __exports__